import apiSlice from "./ApiSlice";

export const accountApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL
    getAllAccounts: builder.query({
      providesTags: ["accounts"],
      query: () => {
        return {
          url: "/account",
          method: "GET",
        };
      },
    }),

    // GET
    getAccounts: builder.query({
      providesTags: ["accounts"],
      query: (body) => {
        return {
          url: "/account",
          method: "POST",
          body,
        };
      },
    }),

    // ADD
    addAccount: builder.mutation({
      invalidatesTags: ["accounts"],
      query: (body) => {
        return {
          url: "/account/add",
          method: "POST",
          body,
        };
      },
    }),
    // DELETE
    deleteAccount: builder.mutation({
      invalidatesTags: ["accounts"],
      query: (id) => {
        return {
          url: `/account/${id}`,
          method: "DELETE",
        };
      },
    }),
    // GET ACCOUNT BY ID
    getAccountById: builder.query({
      providesTags: ["accounts"],
      query: ({ id }) => {
        return {
          url: `/account/${id}`,
          method: "GET",
        };
      },
    }),
    // EDIT
    editAccount: builder.mutation({
      invalidatesTags: ["accounts"],
      query: ({ body, id }) => {
        return {
          url: `/account/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useGetAllAccountsQuery,
  useGetAccountsQuery,
  useAddAccountMutation,
  useDeleteAccountMutation,
  useGetAccountByIdQuery,
  useEditAccountMutation,
} = accountApi;
